<template>
  <Table style="margin-top: 1rem;" class="panorama-summary-table">
    <TableHeader>
      <TableRow>
        <TableHead
          v-for="(panoramaSummaryCol, index) of panoramaSummaryColumns"
          :key="`${panoramaSummaryCol.label}_${index}`"
        >
          <span>{{ panoramaSummaryCol.label }}</span>
        </TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow
        v-for="(panoramaSummary, index) of panoramaStatusSummaryList"
        :key="`${panoramaSummary.name}_${index}`"
      >
        <TableCell
          class="panorama-summary-table-cell"
          :style="setInvoiceSummaryStatusColor(panoramaSummary.name)"
        >
          {{ translatePanoramaSummaryStatusName(panoramaSummary.name) }}
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <div>
            <RenderMoneyColumnValue
              v-if="
                panoramaSummary.name.substring(2, 3) === '0' ||
                  ['B', 'K', 'T'].includes(panoramaSummary.name.substring(2, 3))
              "
              :value="
                !['B', 'K', 'T'].includes(panoramaSummary.name.substring(2, 3))
                  ? getTotalAmountByStatusPrefix(
                      panoramaSummary.name.substring(1, 2),
                      panoramaStatusSummaryList,
                    ) || 0
                  : panoramaSummary.total || 0
              "
              :max-fraction-digits="0"
            />
            |
            <RenderPercentageColumnValue
              :value="panoramaSummary.percentageOfTotal"
            />
          </div>
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderMoneyColumnValue
            :value="panoramaSummary.subtotal"
            :max-fraction-digits="0"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.january)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.january)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.february)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.february)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.march)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.march)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.april)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.april)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.may)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.may)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.june)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.june)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.july)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.july)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.august)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.august)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.september)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.september)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.october)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.october)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.november)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.november)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
        <TableCell
          class="panorama-summary-table-cell"
          style="text-align: right;"
        >
          <RenderPanoramaSummaryInvoiceLine
            :invoice-value="
              getSumBoletoVeinsByPanoramaList(panoramaSummary.december)
            "
            :percentage-invoice-value="
              getSumPercentageByPanoramaList(panoramaSummary.december)
            "
            :status="panoramaSummary.name"
          />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</template>

<script>
import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../ui/render';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../ui/table';
import { setPanoramaInvoiceStatusColor } from '../utils';
import { sumColumnValueByListAndColumn } from '../../../utils';
import { RenderPanoramaSummaryInvoiceLine } from '.';

/**
 * @typedef {Object} InvoiceData
 * @property {number} boletoVeins
 * @property {string} status
 */

/**
 * Objeto que representa as Faturas Atrasadas em modelo para a construção da tabela de Resumo
 * @typedef {Object} PanoramaInvoiceSummary
 * @property {string} name Nome do status judicial.
 * @property {number} total Valor total dos boletos vencidos.
 * @property {number} subtotal Subtotal dos boletos vencidos.
 * @property {number} qtyInvoceInStatus Quantidade de faturas naquele status.
 * @property {InvoiceData[] | null} january Lista de faturas vencidas em janeiro.
 * @property {InvoiceData[] | null} february Lista de faturas vencidas em fevereiro.
 * @property {InvoiceData[] | null} march Lista de faturas vencidas em março.
 * @property {InvoiceData[] | null} april Lista de faturas vencidas em abril.
 * @property {InvoiceData[] | null} may Lista de faturas vencidas em maio.
 * @property {InvoiceData[] | null} june Lista de faturas vencidas em junho.
 * @property {InvoiceData[] | null} july Lista de faturas vencidas em julho.
 * @property {InvoiceData[] | null} august Lista de faturas vencidas em agosto.
 * @property {InvoiceData[] | null} september Lista de faturas vencidas em setembro.
 * @property {InvoiceData[] | null} october Lista de faturas vencidas em outubro.
 * @property {InvoiceData[] | null} november Lista de faturas vencidas em novembro.
 * @property {InvoiceData[] | null} december Lista de faturas vencidas em dezembro.
 */

export default {
  components: {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TableHeader,
    RenderMoneyColumnValue,
    RenderPercentageColumnValue,
    RenderPanoramaSummaryInvoiceLine,
  },
  props: {
    /**
     * Lista de Faturas por status
     * @default []
     * @type {PanoramaInvoiceSummary[]}
     */
    panoramaStatusSummaryList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      panoramaSummaryColumns: [
        {
          key: 'invoice',
          label: 'Fatura',
        },
        {
          key: 'total',
          label: 'Total',
        },
        {
          key: 'subtotal',
          label: 'Subtotal',
        },
        {
          key: 'january',
          label: 'Janeiro',
        },
        {
          key: 'february',
          label: 'Fevereiro',
        },
        {
          key: 'march',
          label: 'Março',
        },
        {
          key: 'april',
          label: 'Abril',
        },
        {
          key: 'may',
          label: 'Maio',
        },
        {
          key: 'june',
          label: 'Junho',
        },
        {
          key: 'july',
          label: 'Julho',
        },
        {
          key: 'august',
          label: 'Agosto',
        },
        {
          key: 'september',
          label: 'Setembro',
        },
        {
          key: 'october',
          label: 'Outubro',
        },
        {
          key: 'november',
          label: 'Novembro',
        },
        {
          key: 'december',
          label: 'Dezembro',
        },
      ],
    };
  },
  methods: {
    /**
     * Retorna o total dos valores de Boleto Veins dado uma lista de Faturas atrasadas
     *
     * @param {PanoramaInvoiceSummary[]} panoramaList
     * @returns {function(): number}
     */
    getSumBoletoVeinsByPanoramaList(panoramaList) {
      return sumColumnValueByListAndColumn('boletoVeins', panoramaList);
    },
    /**
     * Retorna o total de porcentagem dado uma lista de Faturas atrasadas
     *
     * @param {PanoramaInvoiceSummary[]} panoramaList
     * @returns {function(): number}
     */
    getSumPercentageByPanoramaList(panoramaList) {
      return sumColumnValueByListAndColumn('percentageOfTotal', panoramaList);
    },
    /**
     * Calcula o valor total dos boletos vencidos para um determinado prefixo de status judicial.
     *
     * @param {string} statusPrefix - Prefixo do status judicial para filtrar (primeira letra do status).
     * @param {PanoramaInvoiceSummary[]} panoramaInvoiceSummaryList - Lista de resumos de faturas vencidas, agrupadas por status e mês.
     *
     * @returns {number} O valor total dos boletos vencidos para o prefixo de status especificado.
     *
     * @example
     * const total = getTotalAmountByStatusPrefix('L', panoramaInvoiceSummaryList);
     * console.log(total); // Output: valor total dos boletos vencidos para status que começam com 'L'
     */
    getTotalAmountByStatusPrefix(statusPrefix, panoramaInvoiceSummaryList) {
      let total = 0;
      panoramaInvoiceSummaryList.forEach(panoramaInvoice => {
        if (panoramaInvoice.name.substring(1, 2) === statusPrefix) {
          total = total + panoramaInvoice.subtotal;
        }
      });
      return total;
    },
    /**
     * Retorna o estilo CSS associado a um status de resumo de fatura específico.
     *
     * @param {string} name - O nome do status de resumo da fatura.
     * @returns {string} O estilo CSS associado ao status de resumo da fatura.
     */
    setInvoiceSummaryStatusColor(name) {
      return setPanoramaInvoiceStatusColor(name);
    },
    translatePanoramaSummaryStatusName(name) {
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-summary-table {
  display: block;

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 5.5rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 2) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 2) {
    background-color: #f2f2f2;
  }
}
.panorama-summary-table-cell {
  height: 20px !important;
}
</style>
